import { render, staticRenderFns } from "./SettingsView.vue?vue&type=template&id=39a07362&scoped=true"
import script from "./SettingsView.vue?vue&type=script&lang=js"
export * from "./SettingsView.vue?vue&type=script&lang=js"
import style0 from "./SettingsView.vue?vue&type=style&index=0&id=39a07362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a07362",
  null
  
)

export default component.exports